import {EventEmitter} from '@angular/core';
import {
  Expose, instanceToPlain,
  plainToClassFromExist,
  plainToInstance,
  Type
} from 'class-transformer';

import {EntityArray} from '../core/entityArray';
import {WorkerFile} from '../entities/file';
import {Helper} from '../helpers/helper';
import {LookinChatSDK} from '../lib/lookinChatSDK';
import {ApiResponse} from '../entities/apiResponse';

/**
 * @ignore
 * @internal
 * */
export class WorkerAPI {
  public workers: WorkersCollection = new WorkersCollection();

  private workerQueueTimer: number = null;
  private workerQueueTime = 300;

  getWorker(workerId: number = null) {
    let workerStore = this.workers.getById(workerId);

    if (!workerStore) {
      workerStore = new WorkerStore(workerId);
      this.workers.push(workerStore);
    }

    this.runWorkerQueue();

    return workerStore;
  }

  private runWorkerQueue() {
    if (this.workerQueueTimer === null && this.getWaitingWorkers().length > 0) {

      this.workerQueueTimer = setTimeout(() => {

        const workerQueue = this.getWaitingWorkers();

        if (workerQueue.length) {
          const workerToLoadIds: number[] = this.getWaitingWorkers().map(item => item.id);

          workerQueue.forEach((item) => item.loadingStatus = 'loading')

          this.ApiCall(workerToLoadIds, (workers) => {
            workerToLoadIds.forEach((workerId) => {
              const worker = workers.find((item) => item.id.toString() === workerId.toString());
              const workerStore = this.workers.getById(workerId)
              workerStore.worker = worker;
            })
          })
        }

        clearTimeout(this.workerQueueTimer);
        this.workerQueueTimer = null;

      }, this.workerQueueTime)
    }
  }

  private getWaitingWorkers() {
    return this.workers.getAllByField('loadingStatus', 'waiting');
  }

  private ApiCall(workerToLoadIds: number[] = [], callback: (workers: Worker[]) => void) {
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;

    xhr.addEventListener('readystatechange', (res) => {
      if (xhr.readyState === 4) {
        const response = new ApiResponse(JSON.parse(xhr.responseText));

        if (response.status) {
          callback(plainToInstance(Worker, response.result.items) as unknown as Worker[]);
        } else {
          console.error(response.message);
        }
      }
    });

    // &id[]=444&id[]=444&id[]=444
    const ids = `&id[]=${workerToLoadIds.join('&id[]=')}`
    const token = `&auth_key=${LookinChatSDK.instance.config.userToken}`
    // const token = `&auth_key=93Ly6NYbayho7JjOnrQVGxnLKWJZU9Fz`
    const url = `${LookinChatSDK.instance.config.sakuraUrl}index.php?r=api/pwa/worker-list${ids}${token}`;

    xhr.open('GET', url);

    xhr.setRequestHeader('Content-Type', '');
    xhr.setRequestHeader('Accept', 'application/json');

    xhr.send();
  }

  private getTestWorker(): Partial<Worker>[] {
    return [
      {
        id: 1,
        name: 'Работник 1',
        photo: {
          'id': 519,
          'title': '218_puppy-dog-pet_640x960_1686126626',
          'url': '/upload/profile/218_puppy-dog-pet_640x960_1686126626.jpg',
          'extension': 'jpg',
          'type': 'image',
          'color': '#B4ABB1',
          'dateCreated': '2023-06-07T11:30:26+03:00',
          'thumbnails': [
            {
              'size': 200,
              'url': '/upload/profile/thumbnails/218_puppy-dog-pet_640x960_1686126626_200.webp'
            },
            {
              'size': 400,
              'url': '/upload/profile/thumbnails/218_puppy-dog-pet_640x960_1686126626_400.webp'
            },
            {
              'size': 800,
              'url': '/upload/profile/thumbnails/218_puppy-dog-pet_640x960_1686126626_800.webp'
            },
            {
              'size': 1600,
              'url': '/upload/profile/thumbnails/218_puppy-dog-pet_640x960_1686126626_1600.webp'
            }
          ]
        }
      },
      {
        id: 2,
        name: 'Работник 2',
        photo: {
          'id': 328,
          'title': 'photo_2023-01-16_17-58-22_1676028194',
          'url': '/upload/profile/photo_2023-01-16_17-58-22_1676028194.jpg',
          'extension': 'jpg',
          'type': 'image',
          'color': '#322D2D',
          'dateCreated': '2023-02-10T14:23:14+03:00',
          'thumbnails': [
            {
              'size': 200,
              'url': '/upload/profile/thumbnails/photo_2023-01-16_17-58-22_1676028194_200.webp'
            },
            {
              'size': 400,
              'url': '/upload/profile/thumbnails/photo_2023-01-16_17-58-22_1676028194_400.webp'
            },
            {
              'size': 800,
              'url': '/upload/profile/thumbnails/photo_2023-01-16_17-58-22_1676028194_800.webp'
            },
            {
              'size': 1600,
              'url': '/upload/profile/thumbnails/photo_2023-01-16_17-58-22_1676028194_1600.webp'
            }
          ]
        }
      },
      {
        id: 3,
        name: 'Работник 3',
        photo: null
      },
      {
        id: 4,
        name: 'Работник 4',
        photo: {
          'id': 375,
          'title': '1_1680865110',
          'url': '/upload/profile/1_1680865110.jpeg',
          'extension': 'jpeg',
          'type': 'image',
          'color': '#9E8E67',
          'dateCreated': '2023-04-07T13:58:30+03:00',
          'thumbnails': [
            {
              'size': 200,
              'url': '/upload/profile/thumbnails/1_1680865110_200.webp'
            },
            {
              'size': 400,
              'url': '/upload/profile/thumbnails/1_1680865110_400.webp'
            },
            {
              'size': 800,
              'url': '/upload/profile/thumbnails/1_1680865110_800.webp'
            },
            {
              'size': 1600,
              'url': '/upload/profile/thumbnails/1_1680865110_1600.webp'
            }
          ]
        }
      },
    ]
  }
}

/**
 * @ignore
 * @internal
 * */
export class WorkersCollection extends EntityArray<WorkerStore> {

}

/**
 * This object needed to store data about user,<br>
 * will load by API or refresh if needed.<br>
 * */
export class WorkerStore {
  /**
   * Worker ID
   * */
  public id: number;

  /**
   * This event will be called each time when user store get change.<br>
   * If {@link worker changed}
   * If {@link loadingStatus changed}
   *
   * @event
   * */
  public updateEvent = new EventEmitter<void>();

  private _worker: Worker = new Worker();

  /**
   * Worker Class, same as in Sakura APP
   * */
  get worker(): Worker {
    return this._worker;
  }

  /**
   * @ignore
   * @internal
   * */
  set worker(worker: Partial<Worker>) {
    this._loadingStatus = worker ? 'ready' : 'notFound';
    this._worker = worker ? plainToClassFromExist(this._worker, worker) : new Worker();

    this.updateEvent.emit();
  }

  private _loadingStatus: WorkerDataStatus = 'waiting';

  /**
   * Loading status of worker store See {@link WorkerDataStatus}
   * */
  get loadingStatus(): WorkerDataStatus {
    return this._loadingStatus;
  }

  /**
   * @ignore
   * @internal
   * */
  set loadingStatus(value: WorkerDataStatus) {
    this._loadingStatus = value;

    this.updateEvent.emit();
  }

  constructor(workerId: number) {
    this.id = workerId;
  }

  // @todo add date loaded check

  // dateLoaded?: Date = new Date()
  //
  // notVeryOld?() {
  //   const now = new Date();
  //   return Helper.diffBetweenDatesMinutes(now, this.dateLoaded) <= 20;
  // }
}

/**
 * Loading status of worker store<br>
 * - `waiting`, store was created and waiting to be requested from server
 * - `loading`, requested from server
 * - `ready`, ready to use
 * - `notFound`, worker was not found by api call
 * */
export type WorkerDataStatus = 'waiting' | 'loading' | 'ready' | 'notFound';

/**
 * Same as Worker object in Sakura APP
 * */
export class Worker {

  id: number = null;
  private _name: string = null;
  get name(): string {
    return this._name ? this._name : 'Нет имени';
  }

  set name(value: string) {
    this._name = value;
  }

  @Type(() => WorkerFile)
  photo?: WorkerFile = null;

  birthday?: string;
  email?: string;

  // На будущие времена, объяснение почему заменил @Expose на набор гет-сеттеров:
  //  @Expose не работает как задумывалось. При первом определении все норм:
  //  1. с бэка приходит сущность Worker у которой поле filials
  //  2. в класс Worker этот filials записывается как branch. В итоге у класса Worker есть поле branch и больше нет поля filials
  //  А вот при повторной перезаписи данных (которая происходит в set worker() ) начинаются проблемы:
  //  1. в таргет-класс Worker в поле branch пишется значение поля filials сорс-класса Worker (которое, у _класса_ Worker не существует, оно было заменено полем branch)
  //  2. В результате при любой перезаписи в класс Worker поле branch перезаписывается на undefined, всегда.
  //  Т.е. фокус с @Expose работал бы, если бы не нужно было перезаписывать this.worker через класс-трансформер.
  //  В итоге решение а) - заменить @Expose; решение б) - избавиться от перезаписи через класс-трансформер. Я использовал решение а).

  // @Expose({name: 'filial'})
  // branch?: string;

  filial?: string;
  get branch() {
    return this.filial;
  }
  set branch(branch) {
    this.filial = branch;
  }

  gender?: string;
  phone?: string;
  onShift?: boolean = false;

  @Type(() => WorkerStatus)
  status: WorkerStatus;

  getPhoto?(): string {
    return this.photo?.fileUrl();
  }


  // @Expose({name: 'posts'})
  // @Type(() => Position)
  // positions?: Position[] = [];

  @Type(() => Position)
  private _posts?: Position[] = [];
  get posts(): Position[] {
    return this._posts;
  }
  set posts(value: Position[]) {
    this._posts = value;
    this._positions = value;
  }

  @Type(() => Position)
  private _positions?: Position[] = [];
  get positions(): Position[] {
    return this._posts;
  }
  set positions(value: Position[]) {
    this._posts = value;
    this._positions = value;
  }


  getPositionsList?(separator = ' / ') {
    const returnData: string[] = [];
    if (this.positions?.length) {
      this.positions.forEach((key: any, val: any) => {
        returnData.push(key._name);
      });
      return returnData.join(separator);
    } else {
      return null;
    }
  }

  getFormattedPhone?(code = '+7'): string | null {
    return Helper.getFormattedPhone(this.phone, code);
  }

  convertToPlain() {
    const result = instanceToPlain(this);

    result.name = result._name;
    delete result._name;

    result.posts = result._posts;
    delete result._posts;
    delete result._positions;

    return result;
  }
}

/**
 * Same as Worker object in Sakura APP
 * */
export class Position {
  id?: number;

  name: string;
  get title() {
    return this.name;
  }
  set title(value) {
    this.name = value;
  }

  post_code: string;
  get slug() {
    return this.post_code;
  }
  set slug(value) {
    this.post_code = value;
  }
}

export class WorkerStatus {
  id: number;
  title: string;
  isFired?: boolean = false;
}
